import { motion } from 'framer-motion';
import ChipGroup from './ChipGroup';

interface QuickDateOption {
  key: string;
  label: string;
}

interface DatePreferencePickerProps {
  value: string | null;
  onChange: (value: string) => void;
  quickOptions?: QuickDateOption[];
}

const DEFAULT_QUICK_OPTIONS: QuickDateOption[] = [
  { key: 'thisWeek', label: '이번 주' },
  { key: 'nextWeek', label: '다음 주' },
  { key: 'within2Weeks', label: '2주 내' },
  { key: 'withinMonth', label: '1달 내' },
];

function isDateValue(value: string | null) {
  return !!value && /^\d{4}-\d{2}-\d{2}$/.test(value);
}

export default function DatePreferencePicker({
  value,
  onChange,
  quickOptions = DEFAULT_QUICK_OPTIONS,
}: DatePreferencePickerProps) {
  return (
    <div className="space-y-4">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="rounded-2xl bg-white border border-cream-dark p-5"
      >
        <div className="relative">
          <input
            type="date"
            value={isDateValue(value) ? value || '' : ''}
            onChange={(e) => onChange(e.target.value)}
            className="w-full pl-10 pr-4 py-3 bg-cream-light rounded-xl text-sm text-navy border border-cream-dark focus:border-navy focus:outline-none transition-colors appearance-none"
          />
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-navy-light">
            <i className="ri-calendar-line" />
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.25, duration: 0.35 }}
      >
        <ChipGroup
          items={quickOptions.map((option) => option.label)}
          value={!isDateValue(value) ? value : null}
          onSelect={onChange}
        />
      </motion.div>
    </div>
  );
}
